import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import {
  Button,
  Grid,
  Typography,
  IconButton,
  Link as MuiLink,
  useMediaQuery,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Divider
} from "@mui/material";
import imageCompression from "browser-image-compression";

import "../../components/Authentication/Signup/SignUpPage.css";
import { AllTypoFontStyles } from "../../Styles/styles";
import { SignupLeftPage, SignUpWithGoogle } from "../../Svg/icons";
import QuikTix_SignUpBG from "../../Svg/QuikTiks_SignUpBG.svg";
import QuickTixLogo from "../../Images/GX_Logo_White_No_Bg.png";
import BlackQuikTixLogo from "../../Images/GX_Logo_Black_No_Bg.png";
import { LoginRightPage } from "../../Svg/icons";

import {
  FormikInput,
  FormikPassword,
  FormikUpload,
} from "../../components/Authentication/Signup/FormikAntd";
import { validationSchema } from "../../components/Authentication/Signup/Validation";
import {
  useForgotPasswordMutation,
  useRegisterMutation,
} from "../../Redux/Slices/Accounts/AccountsapiSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { notification } from "antd";
import { setVerification } from "../../Redux/Slices/registerverificationSlice";
import { useDispatch } from "react-redux";
import { PhoneNumberUtil } from "google-libphonenumber";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useGoogleLoginMutation } from "../../Redux/apis/ApiSlice";
import { jwtDecode } from "jwt-decode";
const SignUpPage = () => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const dispatch = useDispatch();
  const [googleLogin] = useGoogleLoginMutation();
  const [register, { isLoading }] = useRegisterMutation();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [eventId, setEventId] = useState("");
  const [eventInviteType, setEventInviteType] = useState("");
  const [forgotPassword, { isSuccess, isError, error }] =
    useForgotPasswordMutation();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("US");
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  // useEffect(() => {
  //   const queryParams = new URLSearchParams(location.search);
  //   setEventId(queryParams.get("eventId") || "");
  //   setEventInviteType(queryParams.get("eventInviteType") || "");
  // }, [location]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const handleCredentialResponse = (response) => {
    if (!response.credential) {
      notification.error({
        message: "Google login failed! Please retry.",
      });
      return;
    }

    setIsGoogleLoading(true);

    if (response.credential) {
      const decoded = jwtDecode(response.credential);

      // Extract user details from the decoded JWT
      const { email, given_name: firstName, family_name: lastName } = decoded;

      // Send Google login data to backend
      const data = { email, firstName, lastName };

      googleLogin(data)
        .unwrap()
        .then((res) => {
          if (res.success) {
            localStorage.setItem("authToken", res.token);
            localStorage.setItem("userData", JSON.stringify(res.user));

            notification.success({
              message: "Login successful!",
            });

            navigate("/explore-events");
          } else {
            notification.error({
              message: "User not found! Please sign up.",
            });
            navigate("/signup");
          }
        })
        .catch((error) => {
          console.error("Error during Google Login:", error);
          const status = error.status || error.response?.status || 500;
          const message =
            error.data?.message || "Something went wrong. Please try again.";

          if (status === 500) {
            notification.error({
              message: "Server Error. Please retry later.",
            });
          } else {
            notification.error({
              message: "Something went wrong. Please retry later.",
            });
          }
        })
        .finally(() => {
          setIsGoogleLoading(false); // Hide loader when request completes
        });
    }
  };
  const uploadToS3 = async (file) => {
    try {
      // Compress the image
      const options = {
        maxSizeMB: 1, // Adjust based on your requirements
        maxWidthOrHeight: 1024, // Adjust based on your requirements
        useWebWorker: true,
      };
      const compressedFile = await imageCompression(file, options);

      // Upload the compressed image
      const formData = new FormData();
      formData.append("file", compressedFile);

      const response = await fetch(`${apiUrl}/upload`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("File upload failed");
      }

      const result = await response.json();
      return result.Location; // Return the URL of the uploaded file
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setLoading(true); // Show loading indicator
console.log("Checkk")
    // Check if user is online
    if (!navigator.onLine) {
      notification.error({
        message: "No internet connection!",
      });
      setLoading(false);
      return;
    }

    try {
      let profilePictureUrl = "";
      if (values.profilePicture && values.profilePicture[0]) {
        profilePictureUrl = await uploadToS3(
          values.profilePicture[0].originFileObj
        );
      }

      const data = {
        fullName: values.fullName,
        email: values.email,
        phoneNumber: phoneNumber,
        password: values.password,
        eventId: eventId,
        eventInviteType: eventInviteType,
        profilePic: profilePictureUrl, // Include the profile picture URL
      };
      dispatch(setVerification(data));

      const res = await register(data).unwrap();
      if (res.success) {
        try {
          const response = await forgotPassword(data.email).unwrap();
          if (response.success) {
            notification.success({
              message: "OTP sent successfully!",
            });
            navigate(
              `/verify-account?email=${encodeURIComponent(
                data.email
              )}&from=register`
            );
          }
        } catch (err) {
          console.error("Failed to send email: ", err);
          notification.error({
            message: "Failed to send email!",
          });
        }

        resetForm(); // Clear form fields
      }
    } catch (error) {
      notification.error({
        
        message:
          error?.data?.message || error?.message || "Registration failed!",
      });
    } finally {
      setSubmitting(false);
      setLoading(false); // Hide loading indicator
      setSnackbarOpen(true);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const isMdAbove = useMediaQuery("(min-width:900px)");

  useEffect(() => {
    const initializeGoogleLogin = () => {
      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        scope: "https://www.googleapis.com/auth/contacts.readonly",
        callback: handleCredentialResponse,
      });
      window.google.accounts.id.renderButton(
        document.getElementById("google-signin-button"),
        { theme: "outline", size: "large" }
      );
    };

    if (window.google) {
      initializeGoogleLogin();
    } else {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.onload = initializeGoogleLogin;
      document.body.appendChild(script);
    }
  }, []);
  return (
    <Grid container className="signup-container">
      <Grid
        item
        xs={12}
        md={6}
        className="left-section"
      >
        {isMdAbove ? (
          <LoginRightPage />
        ) : (
          <img
            src={QuickTixLogo}
            alt="GX Tickets"
            style={{ height: "75px" }}
            onClick={() => navigate("/")}
          />
        )}
      </Grid>
      <GoogleOAuthProvider clientId={clientId}>
      <Box sx={{position: 'absolute', top: 20, left: 20, display: { xs: 'none', md: 'block' }}}>
        <img
          src={BlackQuikTixLogo}
          alt="GX Tickets"
          style={{ height: "75px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        />
        </Box>
        <Grid
          item
          xs={12}
          md={6}
          className="right-section"
        >
          {loading ? (
            <CircularProgress /> // Show CircularProgress while loading
          ) : (
            <>
            <Formik
              initialValues={{
                fullName: "",
                email: "",
                phoneNumber: "",
                password: "",
                confirmPassword: "",
                profilePicture: null,
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ setFieldValue, isSubmitting, handleSubmit }) => (
                <form className="signup-form" onSubmit={handleSubmit}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: 30,
                      mb: 2,
                    }}
                  >
                    Sign Up
                  </Typography>

                  <FormikInput
                    name="fullName"
                    label={
                      <Typography
                        sx={{
                          ...AllTypoFontStyles.CommonTypo2,
                          textAlign: "left",
                        }}
                      >
                        Full Name
                      </Typography>
                    }
                    size="large"
                    placeholder="Full Name"
                  />

                  <FormikInput
                    name="email"
                    label={
                      <Typography
                        sx={{
                          ...AllTypoFontStyles.CommonTypo2,
                          textAlign: "left",
                        }}
                      >
                        E-mail
                      </Typography>
                    }
                    size="large"
                    placeholder="E-mail"
                  />
                  <Box sx={{ marginBottom: "16px" }}>
                  
                    <Typography
                      sx={{
                        ...AllTypoFontStyles.CommonTypo2,
                        textAlign: "left",
                      }}
                    >
                      Phone Number
                    </Typography>
                    <div style={{ width: "100%" }}>
                      <PhoneInput
                        style={{
                          width: "100% !important",
                        }}
                        inputStyle={{
                          width: "100%",
                        }}
                        defaultCountry={countryCode}
                        value={phoneNumber}
                        onChange={(value, country) => {
                          setPhoneNumber(value);
                          setCountryCode(country.iso2);
                        }}
                        className="phone-input"
                      />
                    </div>
                  </Box>

                  <FormikPassword
                    name="password"
                    label={
                      <Typography
                        sx={{
                          ...AllTypoFontStyles.CommonTypo2,
                          textAlign: "left",
                        }}
                      >
                        Password
                      </Typography>
                    }
                    size="large"
                    placeholder="Password"
                  />

                  <FormikPassword
                    name="confirmPassword"
                    label={
                      <Typography
                        sx={{
                          ...AllTypoFontStyles.CommonTypo2,
                          textAlign: "left",
                        }}
                      >
                        Confirm Password
                      </Typography>
                    }
                    size="large"
                    placeholder="Confirm Password"
                  />

                  <FormikUpload
                    name="profilePicture"
                    // label={
                    //   <Typography
                    //     sx={{
                    //       ...AllTypoFontStyles.CommonTypo2,
                    //       textAlign: "left",
                    //     }}
                    //   >
                    //     Profile Photo
                    //   </Typography>
                    // }
                    setFieldValue={(field, value) => {
                      setFieldValue(field, value);
                    }}
                    listType="picture"
                    maxCount={1}
                    customRequest={({ file, onSuccess, onError }) => {
                      uploadToS3(file)
                        .then((url) => {
                          setFieldValue("profilePicture", [{ file, url }]);
                          onSuccess();
                        })
                        .catch(onError);
                    }}
                  />

                  <Button
                    variant="outlined"
                    sx={{
                      backgroundColor: "var(--secondary-color)",
                      // borderRadius: 20,
                      color: "white",
                      "&:hover": {
                        color: "grey",
                      },
                      mb: 2,
                    }}
                    type="submit"
                    className="signup-button"
                    disabled={isLoading || isSubmitting}
                  >
                    {isLoading || isSubmitting ? (
                      <CircularProgress size={24} />
                    ) : (
                      "Sign Up"
                    )}
                  </Button>

                  <Box display="flex" alignItems="center" width="100%" my={2}>
                    <Divider sx={{ flexGrow: 1, bgcolor: "black" }} />
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: 16,
                        color: "black",
                        mx: 2, // Adds spacing between text and dividers
                      }}
                    >
                      OR
                    </Typography>
                    <Divider sx={{ flexGrow: 1, bgcolor: "black" }} />
                  </Box>
                  {/* <IconButton>
                  <SignUpWithGoogle />
                </IconButton> */}
                  <IconButton
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      if (!navigator.onLine) {
                        notification.error({
                          message: "No internet connection!",
                        });
                        return; // Prevents Google login popup from opening
                      }

                      // Trigger Google sign-in manually (assuming `google.accounts.id.prompt()` is used)
                      document.getElementById("google-signin-button")?.click();
                    }}
                  >
                    {/* <div id="google-signin-button"> Continue with Google</div> */}
                    {isGoogleLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      <div id="google-signin-button"> Continue with Google</div>
                    )}
                  </IconButton>
                  <Typography
                  variant="body1"
                color="text.secondary"
                    sx={{
                      fontWeight: 400,
                      fontSize: 16,
                      mb: 0.5,
                    }}
                  >
                    Already have an account?{" "}
                    <MuiLink
                      sx={{
                        fontWeight: 400,
                        fontSize: 16,

                        color: "var(--secondary-color)",
                      }}
                      href="/login"
                    >
                      Login
                    </MuiLink>
                  </Typography>
                </form>
              )}
            </Formik>
            </>
          )}
        </Grid>
      </GoogleOAuthProvider>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        action={
          <Button color="inherit" onClick={handleCloseSnackbar}>
            Close
          </Button>
        }
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default SignUpPage;